// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__4wbMc","header":"ClearentDisclaimer_header__seqMV","inner":"ClearentDisclaimer_inner__25ghs"};